/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Pick_TargetInputs */

const cs_pipelines_pick_target = /** @type {(inputs: Pipelines_Pick_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cílová pipeline`)
};

const en_pipelines_pick_target = /** @type {(inputs: Pipelines_Pick_TargetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target pipeline`)
};

/**
* | output |
* | --- |
* | "Target pipeline" |
*
* @param {Pipelines_Pick_TargetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_pick_target = /** @type {((inputs?: Pipelines_Pick_TargetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Pick_TargetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_pick_target(inputs)
	return cs_pipelines_pick_target(inputs)
});